const colors = {
	palette: {
		primary: "#7E0DD6",
		confirm: "#1AB956",
		error: "#D84910",
		tag1: "#5CC395",
		tag2: "#5BD1D7",
		tag3: "#F1C34E",
		link: "#007CBA",
		background: "#F8F9FA"
	},
	greyScale: {
		1: "#000000",
		2: "#212429",
		3: "#495057",
		4: "#969696",
		5: "#ABABAB",
		6: "#ACB5BD",
		7: "#BFBFBF",
		8: "#DDE2E5",
		9: "#E1E1E1",
		10: "#F8F9FA",
		11: "#FFFFFF"
	}
}

export default colors
